import React from 'react';
import FormStore from 'lib/stores/formStore';
import ModalStore, { closeModal } from 'lib/stores/modalStore';
import LoaderStore, { reset } from 'lib/stores/loaderStore';
import Modal from 'lib/components/Modal';

import ResidentPhotoForm from 'HostForms/ResidentPhoto';

const ResidentPhotoModal = () => {
  const { open } = ModalStore.useState(state => state.residentPhotoModal);

  const closeResidentPhotoModal = () => {
    ModalStore.update(state => closeModal(state, 'residentPhoto'));
  };

  const onAfterSubmit = () => {
    FormStore.update(state => { state.resident = {}; });
    LoaderStore.update(reset);

    closeResidentPhotoModal();
  };

  return (
    <Modal
      title="Add Photo"
      onClose={closeResidentPhotoModal}
      acceptMessage="Upload"
      open={open}
      id="residentPhotoModal"
    >
      <ResidentPhotoForm onAfterSubmit={onAfterSubmit} />
    </Modal>
  );
};

export default ResidentPhotoModal;
